<template>
	<span class="cart" v-if="cartItemsCount">
		<span class="cart-icon" />
		{{ cartItemsCount }}
	</span>
</template>

<script>
export default {
	name: 'ProductCart',

	props: {
		cartItemsCount: {
			type: Number,
			default: 0
		}
	}
}
</script>

<style scoped lang="scss">
@import './src/assets/styles/variables';

.cart {
	display: inline-flex;
	align-items: center;
	padding: 3px 6px;
	min-width: 40px;
	color: $white;
	white-space: nowrap;
	vertical-align: top;
	background-color: $semi-dark-blue;
	border-radius: 32px;

	@media (min-width: 640px) {
		padding: 5px 10px;
		min-width: 55px;
		font-size: 16px;
	}

	.cart-icon {
		display: inline-block;
		width: 18px;
		height: 15px;
		margin: -3px 3px -3px 0;
		vertical-align: top;
		background: url('../assets/images/ic_cart.svg') no-repeat 50%;
		background-size: 14px;

		@media (min-width: 640px) {
			width: 20px;
			height: 16px;
			background-size: 20px;
			margin: -4px 4px -4px 0;
		}
	}
}
</style>
